// Presence: what each phone is doing right now (typing, tapping). Ephemeral and peer to peer:
// never stored, never forwarded, fine to lose. Throttled while typing, re-sent as a heartbeat,
// and dropped when a phone goes quiet.
export const PRESENCE_THROTTLE_MS = 60
export const PRESENCE_HEARTBEAT_MS = 4000
export const PRESENCE_TTL_MS = 10000

export const busy = (p) => Object.keys(p).some((k) => k !== 'from')

// Only well-formed fields get through; anything else from a peer is dropped.
export function cleanPresence(p) {
  const out = {}
  if (typeof p?.from === 'string' && p.from.length <= 64) out.from = p.from
  for (const k of ['joining', 'adding', 'editing']) {
    const f = p?.[k]
    if (!f || typeof f !== 'object') continue
    out[k] = {
      name: typeof f.name === 'string' ? f.name.slice(0, 60) : '',
      digits: Number.isInteger(f.digits) ? Math.max(0, Math.min(f.digits, 20)) : 0,
      field: f.field === 'name' || f.field === 'phone' ? f.field : null,
      // The face a guest tapped in the group photo while joining.
      ...(Number.isInteger(f.face) && f.face >= 0 && f.face < 64 ? { face: f.face } : {}),
    }
  }
  if (typeof p?.touching === 'string' && p.touching.length <= 64) out.touching = p.touching
  return out
}

// Join the P2P room for a group. Signaling goes through our Durable Object relay (one per
// room); the roster itself only ever travels over encrypted WebRTC data channels.
